import useStateStore from 'services/store';
import FloatConfigContainer from '../FloatConfigContainer/FloatConfigContainer';
import FloatConfigHeader from '../FloatConfigContainer/FloatConfigHeader/FloatConfigHeader';
import { useEffect, useState } from 'react';
import { TypeColors } from 'services/types';

const PLACEMENTS = [
    {
        id: 'back-of-collar',
        name: 'Back of Collar',
        // obj: 'BACK_OF_COLLAR_Monogram',
    },
    {
        id: 'left-breast-pocket',
        name: 'Left Pocket',
        // obj: 'NoPocket_Monogram',
    },
    {
        id: 'left-stomach',
        name: 'Left Stomach',
        // obj: 'Stomach_Monogram',
    },
    {
        id: 'left-shirt-tail',
        name: 'Left Shirt Tail',
        // obj: 'LEFT_SHIRT_TAIL_Monogram',
    },
    {
        id: 'right-center-cuff',
        name: 'Right Cuff',
        // obj: 'CUFF_CLOSE_Monogram_R',
    },
    {
        id: 'left-center-cuff',
        name: 'Left Cuff',
        // obj: 'CUFF_CLOSE_Monogram_L',
    },
];

const MONO_STYLES = [
    {
        id: 'Arial',
        img: 'images/monogram/arial.png',
    },
    {
        id: 'Bodoni',
        img: 'images/monogram/bodoni.png',
    },
    {
        id: 'Castel',
        img: 'images/monogram/castel.png',
    },
    {
        id: 'Chanceri',
        img: 'images/monogram/chanceri.png',
    },
];

const MONOGRAM_COLORS = [
    {
        id: 'white',
        text: 'white',
        value: '#e1dfd7',
        img: 'images/stitch/1 White.jpg',
    },
    {
        id: 'black',
        text: 'black',
        value: '#000000',
        img: 'images/stitch/Black.jpg',
    },
    {
        id: 'blue',
        text: 'blue',
        value: '#537bae',
        img: 'images/stitch/Blue.jpg',
    },
    {
        id: 'brown',
        text: 'brown',
        value: '#4a231c',
        img: 'images/stitch/Brown.jpg',
    },
    {
        id: 'green',
        text: 'green',
        value: '#133622',
        img: 'images/stitch/Green.jpg',
    },
    {
        id: 'light-blue',
        text: 'light blue',
        value: '#7f97b7',
        img: 'images/stitch/Light Blue.jpg',
    },
    {
        id: 'light-pink',
        text: 'light pink',
        value: '#ebafa1',
        img: 'images/stitch/Light Pink.jpg',
    },
    {
        id: 'navy',
        text: 'navy',
        value: '#081740',
        img: 'images/stitch/Navy.jpg',
    },
    {
        id: 'purple',
        text: 'purple',
        value: '#96749a',
        img: 'images/stitch/Purple.jpg',
    },
    {
        id: 'red',
        text: 'red',
        value: '#c30422',
        img: 'images/stitch/Red.jpg',
    },
];

const Monogram = () => {
    const { activeProductData, activeFabric, setMonogram } = useStateStore();
    const [monogramValue, setMonogramValue] = useState<TypeColors[]>();
    useEffect(() => {
        fetch('data/fabrics.json')
            .then((response) => response.json())
            .then((data) => {
                setMonogramValue(data);
            })
            .catch((error) => {
                console.error('Error fetching fabrics:', error);
            });
    }, []);

    const monogram = activeProductData?.[activeFabric]?.monogram;
    const activePlacement = monogram.activePlacement;
    const placements = monogram.placements;

    return (
        <FloatConfigContainer>
            <FloatConfigHeader />
            <div className="mono-style">
                <div className="add-fee">+ $10/placement</div>
                <div className="placement">
                    <div className="title">PLACEMENT</div>
                    <div className="placement-select">
                        {PLACEMENTS.map((plc) => (
                            <div
                                title={plc.name}
                                onClick={() => setMonogram('activePlacement', plc.id)}
                                key={plc.id}
                                className={`item-placement ${
                                    activeProductData[activeFabric].monogram.activePlacement ===
                                    plc.id
                                        ? 'active'
                                        : ''
                                }`}
                            >
                                <input
                                    checked={placements && placements[plc.id].isVisible}
                                    onChange={() => setMonogram('isVisible', plc.id)}
                                    id={plc.id}
                                    type="checkbox"
                                />
                                <label>{plc.name}</label>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="mono-text">
                    <div className="title">MONOGRAM TEXT</div>
                    <div className="mono-input-container">
                        <input
                            autoComplete="off"
                            disabled={
                                activePlacement && placements
                                    ? !placements[activePlacement].isVisible
                                    : true
                            }
                            onChange={(e) =>
                                e.target.value.trim().length < 7 && activePlacement && placements
                                    ? setMonogram('text', e.target.value)
                                    : () => {}
                            }
                            value={
                                activePlacement && placements && placements![activePlacement].text
                            }
                            className="mono-input placement"
                            type="text"
                            placeholder="Your text here"
                        />
                    </div>
                </div>
                <div className="mono-style">
                    <div className="title">MONOGRAM STYLE</div>
                    <div
                        className={`mono-styles ${
                            monogram.activePlacement &&
                            placements &&
                            activePlacement &&
                            placements[activePlacement].isVisible
                                ? ''
                                : 'unactive'
                        }`}
                    >
                        {MONO_STYLES.map((style) => {
                            return (
                                <div
                                    onClick={() => setMonogram('style', style.id)}
                                    key={style.id}
                                    className={`mono-img-container ${
                                        activePlacement &&
                                        placements &&
                                        placements[activePlacement]['style-id'] === style.id
                                            ? 'active'
                                            : ''
                                    }`}
                                >
                                    <div className="icon-container">
                                        <img
                                            className="check"
                                            src="images/configurator/check.svg"
                                            alt=""
                                        />
                                    </div>
                                    <img alt="" className="mono-img" src={style.img} />
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="mono-colors">
                    <div className="title">MONOGRAM COLOR</div>
                    <div
                        className={`colors-container ${
                            monogram.activePlacement &&
                            placements &&
                            activePlacement &&
                            placements[activePlacement].isVisible
                                ? ''
                                : 'unactive'
                        }`}
                    >
                        {MONOGRAM_COLORS.map((clr) => {
                            return (
                                <div
                                    onClick={() => setMonogram('color', clr.value)}
                                    key={clr.id}
                                    className={`color-option ${
                                        activePlacement &&
                                        placements &&
                                        placements[activePlacement]['color'] === clr.value
                                            ? 'active'
                                            : ''
                                    }`}
                                >
                                    <div className="color-container">
                                        <div className="icon-container">
                                            <img
                                                className="check"
                                                src="images/configurator/check.svg"
                                                alt=""
                                            />
                                        </div>
                                        <img className="main-img" src={clr.img} alt="" />
                                    </div>
                                    <div className="name">{clr.text}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </FloatConfigContainer>
    );
};

export default Monogram;
